import Image from "next/image";
import React from "react";

export default function DynamicImage({
  src,
  alt,
  width = 18,
  height = 18,
  className = "",
  loading,
  title,
}) {
  return (
    <Image
      src={src}
      alt={alt}
      title={title}
      width={width}
      height={height}
      className={className}
      style={{ height: "auto" }} // ✅ fixes the warning
      loading={loading}
    />
  );
}
